import Lottie from "lottie-react";
import React from "react";
import Footer from "../../Shared/Footer/Footer";
import NavigationBar from "../../Shared/NavigationBar/NavigationBar";
import surveillanceLottie from "./Surveillance.json";
import "./SecuritySarvillance.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faBookOpen,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import cam1 from "../../../Images/Product & Services/Surveillance/cam-1.jpg";
import cam2 from "../../../Images/Product & Services/Surveillance/cam-2.jpg";
import cam3 from "../../../Images/Product & Services/Surveillance/touch-lock.jpg";
import cam4 from "../../../Images/Product & Services/Surveillance/touch-lock2.png";
import cam5 from "../../../Images/Product & Services/Surveillance/garrett_metal.jpg";
import cam6 from "../../../Images/Product & Services/Surveillance/garrett_metal2.jpg";
import cam7 from "../../../Images/Product & Services/Surveillance/Suprema1.png";
import cam8 from "../../../Images/Product & Services/Surveillance/Suprema2.jpg";
import cam9 from "../../../Images/Product & Services/Surveillance/PA1.jfif";
import cam10 from "../../../Images/Product & Services/Surveillance/PA2.jfif";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const SecuritySarvillance = () => {
  // Button
  const handleClickCustom = () => {
    window.location.href = "tel:+8801713060441";
  };

  // MUI
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <section>
        <NavigationBar />
      </section>
      <section id="surveillance-herder-section">
        <div className="container container-fluid">
          <div className="row">
            <div className="col-12  justify-content-end surveillance-Lottie-div">
              <Lottie
                animationData={surveillanceLottie}
                loop={true}
                className="surveillance-Lottie"
              />
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 surveillance-head-text-div">
              <div className="surveillance-tags-line">
                <p className="surveillance-tag">Security &</p>
                <h6 className="surveillance-tag-span">SURVEILLANCE</h6>
              </div>
              <div className="surveillance-p1-div">
                <p className="surveillance-p1">
                  Custom software development refers to the creation of software
                  applications tailored to meet specific business requirements.
                  Unlike off-the-shelf software, custom software is designed and
                  developed to fit the unique needs of a particular
                  organization. The development process typically involves close
                  collaboration between the software development team and the
                  client to understand the organization's requirements,
                  constraints, and goals. This leads to the creation of a
                  customized solution that is optimized for the specific needs
                  of the business, delivering improved efficiency and better
                  outcomes compared to generic software solutions. Custom
                  software development can also provide organizations with a
                  competitive advantage by allowing them to differentiate their
                  offerings and better meet the needs of their customers.
                </p>
              </div>
              <div className="surveillance-buttons-div">
                <button
                  onClick={handleClickCustom}
                  className=" btn btn-lg  surveillance-button-demo"
                >
                  <span className="me-2">
                    <FontAwesomeIcon icon={faPhone} />
                  </span>
                  CALL FOR APPOINMENT AND DEMO
                </button>
                <button className=" btn btn-lg  surveillance-button-discover">
                  <span className="me-2">
                    <FontAwesomeIcon icon={faBookOpen} />
                  </span>
                  DISCOVER CASE STUDIES
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container container-fluid" id="tabs-mui">
      <div className="row">
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: "#f8f8f8",
            display: "flex",
            height: 304,
          }}
        >
          <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderColor: "divider" }}
          >
            <Tab className="pe-5" label="HikVision" {...a11yProps(0)} />
            <Tab className="pe-5" label="ZKTEco" {...a11yProps(1)} />
            <Tab className="pe-5" label="Garrett" {...a11yProps(2)} />
            <Tab className="pe-5" label="Suprema" {...a11yProps(3)} />
            <Tab className="pe-5" label="PA System" {...a11yProps(4)} />
          </Tabs>
        </div>
          <TabPanel value={value} index={0}>
            <div className="row">
              <div className=" col-5 tab-cams-div">
                <img className="tabs-cams" src={cam1} alt="" />
                <img className="tabs-cams" src={cam2} alt="" />
              </div>
              <div className="col-7">
                <p>
                  We are providing the end to end IP CCTV Solution for Medium
                  and Large Enterprise Clients.
                </p>
                <ul>
                  <li>NVR or Server bases IP CCTV Solution.</li>
                  <li>Thermal Camera Solution.</li>
                  <li>Face Detection Access Contro</li>
                </ul>
              </div>
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
          <div className="row">
             
              <div className="col-5 tab-cams-div">
                <img className="tabs-cams" src={cam3} alt="" />
                <img className="tabs-cams" src={cam4} alt="" />
              </div>
              <div className="col-7">
                <p>
                  ZKTeco Co., Ltd is a globally renowned enterprise with
                  biometric verifications as its core technique.
                </p>
                <ul>
                  <li>Biometrics Attendance system</li>
                  <li> Face Detection Access Control and Attendance system</li>
                  <li>Archway Gate and metal Detector</li>
                  <li>Gate Barrier System</li>
                </ul>
              </div>
            </div>
            
          </TabPanel>
          <TabPanel value={value} index={2}>
            <div className="row">
              <div className="col-5 tab-cams-div">
                <img className="tabs-cams" src={cam5} alt="" />
                <img className="tabs-cams" src={cam6} alt="" />
              </div>
              <div className="col-7">
                <p>
                  The Garrett is an USA based Company. The company has set goals
                  to empower their customers with better products, better
                  technology and better information.
                </p>
                <ul>
                  <li>Archway Gate and metal Detector</li>
                  <li> Gate Barrier System</li>
                </ul>
              </div>
            </div>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <div className="row">
              <div className=" col-5 tab-cams-div">
                <img className="tabs-cams" src={cam7} alt="" />
                <img className="tabs-cams" src={cam8} alt="" />
              </div>
              <div className="col-7">
                <p>
                  Suprema is a leading global provider of access control, time &
                  attendance, and biometrics solutions.
                </p>
                <ul>
                  <li>Biometrics Attendance system</li>
                  <li> Face Detection Access Control and Attendance system</li>
                </ul>
              </div>
            </div>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <div className="row">
              <div className="col-5 tab-cams-div">
                <img className="tabs-cams" src={cam9} alt="" />
                <img className="tabs-cams" src={cam10} alt="" />
              </div>
              <div className="col-7">
                <p>
                  PA system are announcements of movements at large area with
                  many speakers are widely used to make announcements in public,
                  institutional and commercial buildings and locations.
                </p>
              </div>
            </div>
          </TabPanel>
        </Box>
        </div>
      </section>
      <div className="mb-5 container survillence-broch-down-div">
        <button className="btn btn-lg survillence-broch-down">
          <span className="me-2">
            <FontAwesomeIcon icon={faDownload} />
          </span>
          Download brochure
        </button>
      </div>
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default SecuritySarvillance;
